import Request from 'gd-request';

class ApiProjects {

    constructor() {

    }

    startEnd(projectId,startMoment,endMoment) {
        const params = {
            startDate:  startMoment ? startMoment.format("YYYY-MM-DD") : null,
            endDate: endMoment ? endMoment.format("YYYY-MM-DD") : null,
        };

        return new Request(this,'put','project/'+projectId+"/start-end",params);
    }

    setProjectManager(projectId, userId) {
        return new Request(this,'put','project/'+projectId+'/project-manager',{userId:userId !== -1 ? userId : null});
    }

    setProjectOwner(projectId, userId) {
        return new Request(this,'put','project/'+projectId+'/project-owner',{userId:userId !== -1 ? userId : null});
    }
}


module.exports = ApiProjects;